import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import '../styles';
import {Box} from '@mui/material';

import {COLORS} from '@/styles/colors';

import {BubbleTailIcon} from './BubbleTailIcon';

function isImagePath(path: string): boolean {
  return (
    path.startsWith('http') ||
    path.startsWith('data:image') ||
    /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(path)
  );
}

interface UserMessageBubbleProps {
  text?: string;
  filePreview?: string | null;
}

export const UserMessageBubble = ({
  text,
  filePreview,
}: UserMessageBubbleProps) => {
  const showImage = filePreview && isImagePath(filePreview);

  return (
    <div className="chat-bubble-user-wrapper">
      {filePreview &&
        (showImage ? (
          <img
            src={filePreview}
            alt="uploaded preview"
            className="preview-image-outside-bubble"
          />
        ) : (
          <div
            className="preview-image-outside-bubble"
            title={filePreview ?? ''}>
            {filePreview?.toLowerCase().endsWith('.pdf') && (
              <PictureAsPdfIcon style={{color: 'red'}} />
            )}
            <span>{filePreview ?? 'No file selected'}</span>
          </div>
        ))}

      {text && (
        <div className="chat-bubble user">
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              right: -4,
              color: COLORS.ON_SURFACE_1,
            }}>
            <BubbleTailIcon />
          </Box>
          <span>{text}</span>
        </div>
      )}
    </div>
  );
};
